// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"0dd81e40","732":"f416d4bd","977":"a9367a14"}[chunkId] + ".chunk.js";
};